/*
 * Mensagem de reconhecimento recortada nos cartões da Home e do Feed (FEED-17, AJH-55). O tamanho do texto
 * fica com quem usa; o cartão precisa da classe `group` e de chamar `exposeFullMessageHeight` ao receber o
 * mouse ou o foco.
 */

/**
 * Mensagem cortada em 3 linhas (`4.5em` = 3 × `leading-normal`) e, com o mouse sobre o cartão ou o foco do
 * teclado, inteira (FEED-17). O destino da transição é `--message-height`, medida na entrada. O valor de
 * reserva é a própria altura de repouso, e não `none`: ler o `scrollHeight` recalcula o estilo já com o
 * `:hover`, antes da variável existir, e um `none` nesse instante encerraria a transição sem animar.
 */
export const MENSAGEM_RECORTADA =
  'line-clamp-3 max-h-[4.5em] leading-normal transition-[max-height] duration-jj-slow ease-jj-standard motion-reduce:transition-none group-hover:max-h-[var(--message-height,4.5em)] group-hover:[-webkit-line-clamp:unset] group-focus-visible:max-h-[var(--message-height,4.5em)] group-focus-visible:[-webkit-line-clamp:unset]';

/** Guarda a altura do texto inteiro como destino da transição. */
export function exposeFullMessageHeight(message: HTMLElement | null) {
  message?.style.setProperty('--message-height', `${message.scrollHeight}px`);
}

